export const preferenceName = 'dashboard/preferences';
export const dashboardPreferenceKey = 'default-campaign-performancemax';
